import {
  REQUEST_USERSTATISTICS_FOR_STORE,
  REQUEST_USERSTATISTICS_FOR_STORE_DONE,
  UserStatisticsActions
} from "./types";
import { UserStoreStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchUserStatisticsForStore(): UserStatisticsActions {
  return {
    type: REQUEST_USERSTATISTICS_FOR_STORE,
    payload: []
  };
}

function fetchUserStatisticsForStoreDone(
  userStoreStatistics: ReadonlyArray<UserStoreStatistics>
): UserStatisticsActions {
  return {
    type: REQUEST_USERSTATISTICS_FOR_STORE_DONE,
    payload: userStoreStatistics
  };
}

/* Thunks goes here */
export const thunkFetchUserStatisticsForStore = (
  periodFrom: Date,
  periodTo: Date,
  storeId: string,
  ageFrom: number,
  ageTo: number
) => async (dispatch: any) => {
  try {
    dispatch(fetchUserStatisticsForStore());
    const result = await StatisticsApi.getUserStatisticsForStore(
      periodFrom,
      periodTo,
      storeId,
      ageFrom,
      ageTo
    );

    if (isOk(result)) {
      dispatch(fetchUserStatisticsForStoreDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchUserStatisticsForStoreDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
